












































import { defineComponent, toRefs, PropType, computed, watch, ref } from '@vue/composition-api';
import { AdgroupFormData, FullNormalFormData, CreativeConfig, CampaignFormData } from '@tt4b/ttam-enums';
import ProductDetails from './index';
import Identity from './../../identity/index';
import { useProductDetailValidate } from '@tt4b/ttam-hooks';

const name = 'ttam-product-details-showcase-compose';
export default defineComponent({
  name,
  components: {
    TtamProductDetailsDesc: ProductDetails.TtamProductDetailsDesc,
    TtamProductDetailsProductList: ProductDetails.TtamProductDetailsProductsList,
    TtamProductDetailsProductsListActions: ProductDetails.TtamProductDetailsProductsListActions,
    TtamTiktokIdentityDisplay: Identity.TtamTiktokIdentityDisplay,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const showcaseSpuListFormItem = ref(null);
    const { adgroupData, creativeData, campaignData } = toRefs<{
      adgroupData: AdgroupFormData;
      creativeData: FullNormalFormData;
      campaignData: CampaignFormData;
    }>(props);

    const { productListDataSource, onProductListChange } = ProductDetails.useProductListForShowcase({
      creativeData,
      emit,
    });

    const curIdentity = computed(() => ({
      identityId: creativeData.value.identityId as string,
      identityTtsShopId: creativeData.value.identityTtsShopId as string,
      identityType: creativeData.value.identityType as number,
      identityBcId: creativeData.value.identityBcId as string,
    }));

    const { avatar, displayName: identityName } = Identity.useTikTokIdentityDisplayProps({
      identityInfo: curIdentity,
    });

    const validate = () => {
      showcaseSpuListFormItem.value?.validate?.('change');
    };

    const { openDrawer, clear } = ProductDetails.useListActions(emit);

    const { spuListValidator } = useProductDetailValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });

    watch(
      () => creativeData.value.showcaseSpuList?.length,
      () => {
        validate();
      },
    );

    return {
      avatar,
      identityName,
      name,
      productListDataSource,
      onProductListChange,
      openDrawer,
      clear,
      spuListValidator,
      showcaseSpuListFormItem,
    };
  },
});
